import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@deepguide-ai/ui/dialog'
import { FilePreview, getFileType } from '@/components/evidence-viewer'

type PreviewFile = {
  evidenceFileId?: string
  url: string
  filename: string
  mimeType: string | null
}

export function EvidenceFilePreviewDialog({
  file,
  onClose,
  onEvidenceFileClick,
}: {
  file: PreviewFile | null
  onClose: () => void
  /** Intercept evidence-file links inside a previewed markdown (e.g. procedure
   *  run-summary) to swap this dialog to the clicked file. */
  onEvidenceFileClick?: (href: string) => void
}) {
  const previewType = file ? getFileType(file.mimeType ?? '', file.filename) : null

  return (
    <Dialog open={file !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className='flex h-[85vh] !max-w-[min(1200px,95vw)] flex-col gap-0 overflow-hidden rounded-md border border-dialog p-0 shadow-md'
        closeClassName='top-3.5 right-4'
      >
        <DialogHeader className='min-h-12 justify-center px-4 py-0'>
          <DialogTitle className='truncate pr-8 text-[13px] font-medium text-text-secondary'>
            {file?.filename}
          </DialogTitle>
        </DialogHeader>
        <div className='min-h-0 flex-1 p-4'>
          {file && previewType ? (
            <FilePreview
              file={{ url: file.url, filename: file.filename }}
              type={previewType}
              evidenceFileId={file.evidenceFileId}
              onEvidenceFileClick={onEvidenceFileClick}
            />
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  )
}
